import { toast } from "react-toastify";
import { getSnapshotDetails } from "../../app/api/trendSnapshot";
import { uploadImage } from "../../app/api/uploadTos3";
import { DataNode } from "../../interface/Trends";
import { User } from "../../types";
import {
  getFactoredTrendCurveResponse,
  getKeyForS3PdfGeneration,
} from "../commonUtils";
import { formatDataForColorAnalysisLevel1 } from "../trendSidebarGraphUtils/colorAnalysisUtils";

export const getSnapshotGraphsJSONDataS3KeyForPdfDownload = async (
  snapshotId: number,
  user: User | null,
  userId: string
) => {
  if (!snapshotId || !user) return "";
  try {
    const detailsParams = {
      page: 1,
      numberOfTrends: 1,
      postsPerTrend: 1,
    };
    const snapDetails = await getSnapshotDetails(
      snapshotId,
      user,
      detailsParams
    );
    const barGraphData = snapDetails?.data?.barGraphData;
    const l1ColorAnalysis = snapDetails?.data?.l1ColorAnalysis;
    const l2ColorAnalysis = snapDetails?.data?.l2ColorAnalysis;
    const colorForL3 =
      snapDetails?.data?.snapshot?.genericFilters?.trendAnalysisFilters
        ?.colorForLevel3;
    const lineGraphData = snapDetails?.data?.lineGraphData;
    const filterType =
      snapDetails?.data?.snapshot?.genericFilters?.graphsFilters?.query_type ||
      "Most Popular";

    //color analysis
    let l1Data = null;
    let l2Data = null;
    let l3Data = null;

    //l1 data
    if (l1ColorAnalysis) {
      const data: DataNode = l1ColorAnalysis;
      formatDataForColorAnalysisLevel1(data);
      l1Data = data;
    }
    //l2 Data
    if (l2ColorAnalysis) {
      const data: DataNode = l2ColorAnalysis?.children;
      l2Data = data;
      // Check if l3 data exists
      if (colorForL3) {
        const dataForL3 = data.children?.find(d => d.color === colorForL3);
        if (dataForL3) {
          l3Data = dataForL3;
        }
      }
    }
    const colorAnalysisData = { filterType, l1Data, l2Data, l3Data };
    let overallAnalysisData = null;
    if (barGraphData) {
      overallAnalysisData = {
        filterType,
        overallAnalysisJSON: barGraphData,
      };
    }
    let trendCurvesData = null;
    if (lineGraphData) {
      const trendCurvesJSON = getFactoredTrendCurveResponse(lineGraphData);
      trendCurvesData = {
        filterType,
        trendCurvesJSON,
        trendCurvesUnfactoredJSON: lineGraphData,
      };
    }
    const payloadJsonForS3 = {
      colorAnalysisData,
      overallAnalysisData,
      trendCurvesData,
    };
    const fileName = Number(new Date());
    const key = getKeyForS3PdfGeneration(userId, fileName);
    const response = await uploadImage(key, JSON.stringify(payloadJsonForS3));
    return response.key;
  } catch (error) {
    console.error("Error while generating s3 for snapshot graphs", error, user);
    toast.error("Error while generating s3 for snapshot graphs", {
      hideProgressBar: true,
    });
    return "";
  }
};
